import { StylesConfig } from "react-select";
// Helper to determine if a color is "light" or "dark"
export const getContrastColor = (hexColor: string) => {
    // Remove the # if it exists
    const hex = hexColor.replace("#", "");
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calculate luminance (standard formula)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "black" : "white";
};

// You can use a function to make it dynamic (e.g., changing colors based on props)
export const universalSelectStyles: StylesConfig = {
    container: (styles) => ({
        ...styles,
        flex: 1,
    }),
    control: (styles) => ({
        ...styles,
        flex: 1,
        backgroundColor: "var(--primary-a)",
        color: "white",
        border: "1px solid var(--accent-a)", // Matching your dropzone border
        boxShadow: "none",
        "&:hover": {
            borderColor: "var(--accent-a)",
        },
    }),
    menu: (styles) => ({
        ...styles,
        backgroundColor: "var(--primary-a)",
        zIndex: 999,
    }),
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected
            ? "var(--accent-a)"
            : isFocused
              ? "rgba(255, 255, 255, 0.1)"
              : "var(--primary-a)",
        color: "white",
        ":active": {
            backgroundColor: "var(--accent-a)",
        },
        zIndex: 999,
    }),
    input: (styles) => ({
        ...styles,
        color: "white",
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "white", // This fixes the text color after selection
    }),
    multiValue: (styles) => ({
        ...styles,
        color: "white", // This fixes the text color after selection
        backgroundColor: "var(--accent-a)",
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: "var(--accent-a-contrast)",
    }),
    placeholder: (styles) => ({
        ...styles,
        color: "rgba(255, 255, 255, 0.5)", // Dimmed placeholder
    }),
};

export const universalSelectStylesNoFlex: StylesConfig = {
    container: (styles) => ({
        ...styles,
        margin: "0.25em",
    }),
    control: (styles) => ({
        ...styles,
        backgroundColor: "var(--primary-a)",
        color: "white",
        border: "1px solid var(--accent-a)", // Matching your dropzone border
        boxShadow: "none",
        "&:hover": {
            borderColor: "var(--accent-a)",
        },
    }),
    menu: (styles) => ({
        ...styles,
        backgroundColor: "var(--primary-a)",
        zIndex: 999,
    }),
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected
            ? "var(--accent-a)"
            : isFocused
              ? "rgba(255, 255, 255, 0.1)"
              : "var(--primary-a)",
        color: "white",
        ":active": {
            backgroundColor: "var(--accent-a)",
        },
        zIndex: 999,
    }),
    input: (styles) => ({
        ...styles,
        color: "white",
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "white", // This fixes the text color after selection
    }),
    multiValue: (styles) => ({
        ...styles,
        color: "white", // This fixes the text color after selection
        backgroundColor: "var(--accent-a)",
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: "var(--accent-a-contrast)",
    }),
    placeholder: (styles) => ({
        ...styles,
        color: "rgba(255, 255, 255, 0.5)", // Dimmed placeholder
    }),
};
